module.exports = __webpack_public_path__ + "resources/img/img_rancher4.54d361ff21bd88dcd06bc55cc56b8757.png";